module.exports = __webpack_public_path__ + "static/media/equipment.dd839723.jpg";